import React from 'react';

import './Teams.team.scss';
import ItemMenu from "../forms/menu/MenuComponent";
import {useNavigate} from "react-router-dom";
import Checkbox from "../forms/inputs/Checkboxk";
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

function TeamBase({team, selectedTeams, hoverTeam, onHover, onAddMembers, onDeleteTeam, onProgramTeam, onChange}) {
    const {t} = useTranslation(['common','teams']);
    const navigate = useNavigate();

    const onClickDetail = () => {
        AuditTrail.sendLog(PAGES.TEAMS_LIST, {tag: 'button', event: 'onClick', action: 'click options open detail', team_id: team._id});
        navigate(`/teams/detail/${team._id}`);
    }

    const onClickManage = () => {
        AuditTrail.sendLog(PAGES.TEAMS_LIST, {tag: 'button', event: 'onClick', action: 'click options manage', team_id: team._id});
        navigate(`/teams/manage/${team._id}`);
    }

    const isChecked = () => {
        return selectedTeams.find((t) => t._id === team._id);
    }

    const isHover = () => {
        return hoverTeam && hoverTeam._id === team._id;
    }

    const handleClick = () => {
        AuditTrail.sendLog(PAGES.TEAMS_LIST, {tag: 'row', event: 'onClick', action: 'click row team', team_id: team._id});
        onHover(team);
    }

    const _onAddMembers = () => {
        AuditTrail.sendLog(PAGES.TEAMS_LIST, {tag: 'button', event: 'onClick', action: 'click option add members', team_id: team._id});
        onAddMembers(team);
    }

    const _onProgramTeam = () => {
        AuditTrail.sendLog(PAGES.TEAMS_LIST, {tag: 'button', event: 'onClick', action: 'click option program team', team_id: team._id});
        onProgramTeam(team);
    }

    const _onDeleteTeam = () => {
        AuditTrail.sendLog(PAGES.TEAMS_LIST, {tag: 'button', event: 'onClick', action: 'click option delete team', team_id: team._id});
        onDeleteTeam(team);
    }

    return (
        <div className={`__TeamBase ${isHover() ? 'selected' : ''}`} onClick={handleClick}>
            <div>
                <Checkbox bool={isChecked()} onChange={() => onChange(team)}/>
            </div>
            <div className="name">
                <h3 onClick={onClickDetail}>{team.name}</h3>
            </div>
            <p>{team.users.length+team.teams.length}</p>
            <p>{team.programs.length}</p>
            <div>
                <ItemMenu actionWillRedirect={false} fixed={true} label={'Team Options'} event={PAGES.TEAMS_LIST} eventParams={{team_id: team._id}}>
                    <>
                        <div className="_option" onClick={_onAddMembers}>
                            <p>{t('teams:add-members')}</p>
                        </div>
                        <div className="_option" onClick={onClickManage}>
                            <p>{t('teams:manage-members')}</p>
                        </div>
                        <div className="_option" onClick={_onProgramTeam}>
                            <p>{t('teams:add-to-program')}</p>
                        </div>
                        <div className="_option" onClick={_onDeleteTeam}>
                            <p>{t('teams:remove-team')}</p>
                        </div>
                    </>
                </ItemMenu>
            </div>
        </div>
    );
}

export default TeamBase;
